export default {
    privacyPolicyText: 'Privacy Notice',
    privacyPolicyLink: 'https://aws.amazon.com/privacy/',
}
